import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { auth } from '../../../../../../services';
import { ROOT_API_URL } from '../../../../../../api-config';
import { setTransactionId } from '../../../../../../Redux/Actions/EndUser/StoreActions';
import { loader, toastr } from '../../../../../../Redux/Actions/CommonActions';
import { Alert } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import './Confirmation.scss';
import SpanSpinner from '../../../../../Shared/SpanSpinner/SpanSpinner';
import IsLoading from '../../../../../Shared/Loading/IsLoading';
import { history } from '../../../../../../helpers/history';

import BillingInformation from "../Billing/BillingInformation/BillingInformation";

const successColor = "success";
const errorColor = "danger";
const warningColor = "warning";

class Confirmation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            products: null
        }
    }

    componentDidMount() {
        console.log('confirmation.js');
        console.log(this.props);
        if (this.props.membership.addons.AddtoCartList.length > 0) {

            this.setState({
                products: this.props.membership.addons.AddtoCartList
            });
        }
    }

    confirm = (product) => {
        this.props.loader(true);
        const userId = this.props.membership.userId;
        axios.post(`${ROOT_API_URL}/StripePayment/StripeCustomerCharge`,this.state.products)
        .then((response) => {
            this.props.loader(false);
            this.props.setTransactionId(response.data.transactionId);
            history.push('/payment');
            
        }).catch((response) => {
            console.log(response);
            this.props.toastr(true, response, warningColor);
            this.props.loader(false);
        })
    }

    formatAsDollar(amount) {
        var t = '$' + (Number(amount)).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        return t;
    }

    total = () => {
        var total = 0;
        total = this.props.membership.selectedmembershipPackage.cost + total;

        if(this.state.products){
            for (var i = 0; i < this.state.products.length; i++) {
                let product = this.state.products[i];
    
                if (product.discount) {
                    total = (product.discount * product.quantity) + total;
                } else {
                    total = (product.price * product.quantity) + total;
                }
            }
        }

        if (this.props.membership.donations) {
            for (var i = 0; i < this.props.membership.donations.length; i++) {
                let donation = this.props.membership.donations[i];

                total = donation.amount + total;
            }
        }

        return (Number(total).toFixed(2));
    }

    tax = () => {
        var total = 0;

        if(this.state.products){
            total += (Number(Number(Number(this.shipping() * 0.0825).toFixed(2)) + Number(total))).toFixed(2);

            for (var i = 0; i < this.state.products.length; i++) {
                let product = this.state.products[i];

                if (product.discount) {
                    total = (Number(Number(Number(product.discount * product.quantity * 0.0825).toFixed(2)) + Number(total))).toFixed(2);
                } else {
                    total = (Number(Number(Number(product.price * product.quantity * 0.0825).toFixed(2)) + Number(total))).toFixed(2);
                }          
            } 
        }
       

        return (Number(total).toFixed(2));
    }

    shipping = () => {
        if (this.state.products) {
            return 8.25;
        } else {
            return 0;
        }
    }

    grandTotal = () => {
        let SubTotal = Number(this.total()).toFixed(2);
        let Shipping = Number(this.shipping()).toFixed(2);
        let Tax = Number(Number(this.tax()).toFixed(2))
        let grandTotal = (Number(SubTotal) + Number(Shipping) + Number(Tax)).toFixed(2);

        return (Number(grandTotal)).toFixed(2);
    }

    render() {
        return (
            <div className="confirmationWrapper">
                {this.props.common.loading &&
                    <IsLoading />
                }
                {/*{this.props.common.loading ? (
                    <IsLoading />
                ) : (*/}
                    <div className="confirmationContainer">
                        <div className="col-lg-12" style={{ width: '100%' }}>
                            {this.props.common.visible ? (
                                <Alert
                                    color={this.props.common.color}
                                    isOpen={this.props.common.visible}
                                    style={{ width: '100%' }}
                                >
                                    {this.props.common.message}
                                </Alert>
                            ) : null}
                        </div>
                        <div className="col-lg-7 col-left">
                            <div className="confirmationForm">
                                <h1 className="pt-3 pb-3">Confirm</h1>
                                <h3>Purchase Memberships</h3>
                                <div className="row header">
                                    <div className="col-md-3">
                                        Item(s)
                                    </div>
                                    <div className="col-md-3">
                                        Quantity
                                    </div>
                                    <div className="col-md-3">
                                        Unit Price
                                    </div>
                                    <div className="col-md-3">
                                        Amount
                                    </div>
                                </div>
                                <div className="row body" >
                                    <div className="col-md-3">
                                        {this.props.membership.selectedmembershipPackage.description}
                                    </div>
                                    <div className="col-md-3">
                                        {1}
                                    </div>
                                    <div className="col-md-3">
                                        {this.formatAsDollar(this.props.membership.selectedmembershipPackage.cost)}
                                    </div>
                                    <div className="col-md-3">
                                        {this.formatAsDollar(this.props.membership.selectedmembershipPackage.cost)}
                                    </div>
                                </div>
                                {
                                    this.state.products ?
                                        this.state.products.map((product, key) => {
                                        return (
                                            <div className="row body" key={key}>
                                                <div className="col-md-3">
                                                    {product.title}
                                                </div>
                                                <div className="col-md-3">
                                                    {product.quantity}
                                                </div>
                                                <div className="col-md-3">
                                                    {this.formatAsDollar(product.discount ? product.discount : product.price)}
                                                </div>
                                                <div className="col-md-3">
                                                    {this.formatAsDollar(product.discount ? product.discount * product.quantity : product.price * product.quantity)}
                                                </div>
                                            </div>
                                        )
                                    }) : null
                                }
                                {
                                     this.props.membership.donations ?
                                            this.props.membership.donations.map((donation, key) => {
                                                if (donation.amount > 0) {
                                                    return (
                                                        <div className="row body" key={key}>
                                                            <div className="col-md-3">
                                                                {donation.name}
                                                            </div>
                                                            <div className="col-md-3">
                                                                1
                                                            </div>
                                                            <div className="col-md-3">
                                                                {this.formatAsDollar(donation.amount)}
                                                            </div>
                                                            <div className="col-md-3">
                                                                {this.formatAsDollar(donation.amount)}
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                        }) : null
                                }
                                <div className="row footer">
                                    <div className="col-md-3">
                                        <p>Subtotal</p>
                                        <p>Shipping</p>
                                        <p>Tax</p>
                                        <p className="footer-total-text">Grand Total:</p>
                                    </div>
                                    <div className="col-md-3">
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <p className="borderTop">&nbsp;</p>
                                    </div>
                                    <div className="col-md-3">
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                        <p className="borderTop">&nbsp;</p>
                                    </div>
                                    <div className="col-md-3">
                                        <p>{this.formatAsDollar(this.total())}</p> 
                                        <p>{this.formatAsDollar(this.shipping())}</p>
                                        <p>{this.formatAsDollar(this.tax())}</p>
                                        <p className="footer-total-price">{this.formatAsDollar(this.grandTotal())}</p>
                                    </div>
                                </div>
                            </div>

                            <BillingInformation signup={true}/>
                        </div>
                        <div className="col-lg-5 col-right confirmationBackground"></div>
                    </div>
                {/*)}*/ }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        membership: state.membership,
        common: state.common
    }
}

export default withRouter(connect(mapStateToProps, { loader, toastr, setTransactionId })(Confirmation));